import {useEffect} from 'react';
import {ILabEditDetail} from '../../../../../models/post/lab';
import {useLab} from '../../../../../context/labContext';
import {convertLocationString} from '../helper';
interface IHandleInitDataProps {
  labEditInfo?: ILabEditDetail;
  isSuccess: boolean;
}
const useHandleInitData = ({labEditInfo, isSuccess}: IHandleInitDataProps) => {
  const {updateLab} = useLab();

  useEffect(() => {
    if (isSuccess) {
      const update: ILabAddInfo = {
        owner_age: labEditInfo?.owner_age,
        owner_name: labEditInfo?.owner_name,
        phone_number: labEditInfo?.phone_number,
        national_card: labEditInfo?.national_card,
        speciality: labEditInfo?.speciality,
        city: labEditInfo?.city,

        land_line: labEditInfo?.land_line,
        state: labEditInfo?.state,
        from_hour: String(labEditInfo?.from_hour),
        to_hour: String(labEditInfo?.to_hour),
        result_from_day: String(labEditInfo?.result_from_day),
        result_to_day: String(labEditInfo?.result_to_day),
        guid: labEditInfo?.guid,
        about: labEditInfo?.about,
        title: labEditInfo?.title,
        logo: labEditInfo?.logo,
        license: labEditInfo?.license,
        establishment_year: String(labEditInfo?.establishment_year),
        certificate: labEditInfo?.certificate,
        location: labEditInfo?.location
          ? convertLocationString(labEditInfo?.location)
          : {
              lat: 35.7219,
              lng: 51.3347,
            },
        activity_city: labEditInfo?.activity_city,
        activity_state: labEditInfo?.activity_state,
        activity_field: labEditInfo?.activity_field?.map(item =>
          Number(item.field),
        ),
        services_activity_field: labEditInfo?.activity_field
          ?.map(item =>
            item.lab_tests.map(subitem => {
              return {code: subitem.code, guid: subitem.guid};
            }),
          )
          .flat(),
        isEdit: true,
      };
      updateLab(update);
    }
  }, [isSuccess, labEditInfo]);
};

export default useHandleInitData;
